var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 700,
    id: "svg8",
    viewBox: "0 0 185.20832 185.20832",
    width: 700,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(244.17261,202.68451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2151",
    transform: "translate(708.39452,-1395.2419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -172.90538,-1050.9226 c 3.39877,-2.5377 2.99925,-7.8285 0,-10.8277 l -36.20385,-36.2043 c -2.99924,-2.9992 -7.82831,-2.9992 -10.82755,0 l -58.71681,58.6149 -58.63793,58.53587 c -3.02589,18.77157 -6.1309,37.62221 -9.15691,56.3938 l 56.18187,-9.36844 c 30.37245,-30.37282 44.72497,-44.67089 59.21122,-59.10268 14.48613,-14.43185 28.73348,-28.62465 58.14996,-58.04145 z",
    id: "path851",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 67.306938,
    id: "rect919",
    ry: 5.0819001,
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(-0.70710294,0.70711062,-0.70710294,-0.70711062,0,0)",
    width: 11.06725,
    x: -601.16461,
    y: 865.35944
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -312.8744,-925.23385 -32.29813,-32.29847 -1.2759,33.12229 z",
    id: "path925",
    style: {
      fill: "#000000",
      stroke: "none",
      strokeWidth: "0.26458332px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 67.306938,
    id: "rect927",
    ry: 5.0819001,
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(-0.70710294,0.70711062,-0.70710294,-0.70711062,0,0)",
    width: 11.06725,
    x: -467.45428,
    y: 865.7829
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2099",
    transform: "translate(-22.7253,-737.9912)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -352.55511,
    cy: -1716.3115,
    id: "path1009",
    rx: 5.3341513,
    ry: 5.3419828,
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -352.55512,-1698.4895 v 37.8585",
    id: "path1011",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -436.72159,-1743.2881 c -2.10926,0 -3.80747,1.7045 -3.80747,3.8223 v 103.5679 c 0,2.1178 1.69821,3.8231 3.80747,3.8231 h 23.24053 v 36.2859 l 71.37453,-36.2859 h 31.63448 42.08329 c 2.10914,0 3.80758,-1.7053 3.80758,-3.8231 v -103.5679 c 0,-2.1178 -1.69844,-3.8223 -3.80758,-3.8223 z",
    id: "rect1013",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2242",
    transform: "translate(556.42558,-843.56901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -1849.9638,-304.30968 h 41.1225 l 69.633,-108.80316 h 23.9087 41.1225",
    id: "path1080",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1674.1771,-413.11286 -39.6587,-19.99314",
    id: "path1084",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1674.1771,-413.11286 -39.6587,19.99316",
    id: "path1100",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1674.1771,-304.30968 -39.6587,-19.99316",
    id: "path1106",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1674.1771,-304.30968 -39.6587,19.99316",
    id: "path1108",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1850.0108,-413.10521 h 41.1225 l 69.6331,108.80316 h 23.9086 41.1226",
    id: "path1092",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2234",
    transform: "translate(-396.85889,-1264.9155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -867.12106,-414.18708 h 104.67358 c 3.37276,0 6.08811,2.70492 6.08811,6.06485 v 144.09387 c 0,3.35992 -2.71535,6.06484 -6.08811,6.06484 h -104.67358 c -3.37287,0 -6.08822,-2.70492 -6.08822,-6.06484 v -144.09387 c 0,-3.35993 2.71535,-6.06485 6.08822,-6.06485 z",
    id: "rect989-9",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -872.7638,-428.6037 h 116.31654",
    id: "path1131",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -847.83449,-394.01058 v 115.87056",
    id: "path1133",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -814.78433,-394.01058 v 115.87056",
    id: "path1135",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -781.73416,-394.01058 v 115.87056",
    id: "path1137",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -831.68517,-433.91096 h 34.15927",
    id: "path1139",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2165",
    transform: "translate(-1842.2183,-908.82736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -508.09411,-666.26096 -2.7e-4,50.63486 c 0,1.26357 -0.84285,2.2808 -1.89013,2.2808 h -172.17305 c -1.04714,0 -1.89013,-1.01723 -1.89013,-2.2808 v -50.63486",
    id: "rect1147",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041508,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1663",
    transform: "matrix(1,0,0,-1,-440.26952,-837.77833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -155.80138,-47.138367 V -197.97334",
    id: "path1149",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -155.80138,-197.97325 -43.48169,44.42384",
    id: "path1151",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -155.80138,-197.97325 43.4817,44.42384",
    id: "path1153",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2170",
    transform: "translate(-1852.3955,-902.05838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -190.13824,-620.9037 -1.6e-4,-175.78177",
    id: "path1239",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -154.99508,-620.80411 -70.28647,-1.5e-4",
    id: "path1241",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -154.99492,-796.78492 -70.28647,-1.5e-4",
    id: "path1243",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2065",
    transform: "translate(150.40038,-731.4105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -1004.9363,-1676.1193 h 175.8228",
    id: "path1247",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1004.9363,-1735.3048 h 175.8228",
    id: "path1249",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1004.9363,-1616.9339 h 175.8228",
    id: "path1251",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1580",
    style: {
      strokeWidth: 0.69996077
    },
    transform: "matrix(1.4022306,0,0,1.4555701,666.00715,-1856.0442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -127.05,-111.18531 v 84.939867 h -97.20364 v -120.685337 0 h 59.76009",
    id: "path1339",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 6.48192835,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -128.34411,-109.94993 h -36.14952 c -0.71698,0 -1.2941,-0.55098 -1.2941,-1.23539 v -34.51006 c 0,-0.6844 0.57712,-1.23539 1.2941,-1.23539 l 37.44363,35.74545 c 0,0.68441 -0.57721,1.23539 -1.29411,1.23539 z",
    id: "path1341",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 6.48192835,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1592",
    style: {
      strokeWidth: 0.71462166
    },
    transform: "matrix(1.4033843,0,0,1.3953112,96.113039,8.7429717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1584",
    style: {
      strokeWidth: 0.87175673
    },
    transform: "matrix(0.82034858,0,0,0.81914972,-1000.8153,8.5908661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1064.0341,-145.82398 V -37.473971 H 945.66383 v -153.947239 0 h 72.77317",
    id: "path1325",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 8.0728302,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1062.4582,-144.24812 h -44.0213 c -0.8731,0 -1.5759,-0.70284 -1.5759,-1.57588 v -44.02132 c 0,-0.87303 0.7028,-1.57588 1.5759,-1.57588 l 45.5972,45.5972 c 0,0.87304 -0.7029,1.57588 -1.5759,1.57588 z",
    id: "rect1297",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 8.0728302,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m -203.7267,-65.835945 h 56.15017",
    id: "path1343",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 6.61769342,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -203.7267,-86.588292 h 56.15017",
    id: "path1345",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 6.61769342,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -203.7267,-45.083597 h 56.15017",
    id: "path1347",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 6.61769342,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2117",
    transform: "translate(604.59967,-721.43969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -1479.3042,-1348.6137 c 43.987,0 87.974,0 131.9609,0 14.6624,14.6623 29.3246,29.3246 43.9869,43.9869 0,43.987 0,87.974 0,131.961 -58.6493,0 -117.2985,0 -175.9478,0 0,-58.6493 0,-117.2986 0,-175.9479 z",
    id: "rect1357",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041508,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 47.425125,
    id: "rect1361",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041508,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 72.677277,
    x: -1427.6688,
    y: -1348.6138
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1377.3937,-1332.8778 v 15.4954",
    id: "path1365",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041508,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1379",
    style: {
      strokeWidth: 0.86788404
    },
    transform: "matrix(1.1522276,0,0,1.1522276,2485.573,-1321.0163)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 61.570217,
    id: "rect1363",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 8.03696728,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 98.601219,
    x: -3414.0032,
    y: 67.180763
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1373",
    style: {
      strokeWidth: 0.86788404
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -3332.2349,86.815572 h -64.9352",
    id: "path1367",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 8.03696823,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -3332.2349,109.11617 h -64.9352",
    id: "path1369",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 8.03696823,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1607",
    transform: "translate(1226.3558,-2041.9376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -270.94092,-413.33916 v 22.49361 m -104.45723,0 v -62.72064 0 h 64.21954",
    id: "path1381",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -272.33159,-411.94889 h -38.8471 c -0.77048,0 -1.39067,-0.62007 -1.39067,-1.39028 v -38.83674 c 0,-0.77021 0.62019,-1.39028 1.39067,-1.39028 l 40.23777,40.22702 c 0,0.77021 -0.62029,1.39028 -1.39067,1.39028 z",
    id: "path1383",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -263.92908,-373.52177 h 12.75166",
    id: "path1410",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -374.82216,-325.24597 h -36.32141 v -64.50356 0 h 175.9479 v 64.50356 h -33.49189",
    id: "path1402",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1597",
    transform: "translate(-171.60118,-248.72845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -181.73851,-68.859629 h 60.34023",
    id: "path1385",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -181.73851,-50.007184 h 60.34023",
    id: "path1389",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 61.087173,
    id: "rect1393",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041698,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 106.13478,
    x: -204.63582,
    y: -89.977005
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2246",
    transform: "translate(-651.26232,-907.69052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -1479.1986,143.76773 175.8543,-175.854357",
    id: "path1419",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1479.1986,-32.086627 175.8543,175.854387",
    id: "path1421",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2077",
    transform: "translate(238.12565,-1067.7833)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -344.66565,
    cy: -2283.1392,
    id: "ellipse1423",
    rx: 57.371502,
    ry: 56.435123,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(0.70704084,-0.70717272,0.70704084,0.70717272,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1738.9413,-1251.8221 -79.1058,-79.1204",
    id: "path1425",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2129",
    transform: "translate(986.16305,-854.72512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -925.98217,-1197.0125 h -35.14851 v -18.3158 0 h 35.14851 z",
    id: "path1455",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1632",
    transform: "translate(-791.98798,-1017.274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -80.133301,-22.106398 H -223.0036 v -157.632072 0 h 142.870299 z",
    id: "path1451",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -106.55211,-167.13593 h -90.03267 v -6.88925 0 h 90.03267 z",
    id: "path1457",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1488",
    style: {
      strokeWidth: 0.85923588
    },
    transform: "matrix(1.1649225,0,0,1.162728,3430.166,-880.5536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1628"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -3788.4218,-212.55864 h 68.3772",
    id: "path1343-2",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.956882,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -3788.4218,-237.18328 h 68.3772",
    id: "path1345-2",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.956882,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -3788.4218,-187.93401 h 68.3772",
    id: "path1347-0",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.956882,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -3788.9913,-163.30937 h 68.3772",
    id: "path1347-0-7",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.956882,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2178",
    transform: "translate(-1784.9094,-907.8804)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 704.22473,
    cy: -258.69522,
    id: "ellipse1490",
    rx: 23.976822,
    ry: 23.822092,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26110744,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(0.50750515,-0.86164873,0.87029421,0.49253221,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 185.26258,-702.97257 -32.84212,-18.58659",
    id: "path1492",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -519.54413,
    cy: 454.93579,
    id: "ellipse1494",
    rx: 23.976822,
    ry: 23.822092,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26110744,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(0.50750515,0.86164873,0.87029421,-0.49253221,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185.26258,-702.97257 152.42046,-684.386",
    id: "path1496",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 185.2703,-702.96933 98.805,-29.77729",
    id: "path1498",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 185.2703,-702.96933 98.805,29.7773",
    id: "path1500",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2260",
    transform: "translate(-375.2092,-976.96741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1542",
    style: {
      strokeWidth: 0.65704465
    },
    transform: "matrix(1.5226963,0,0,1.5212372,447.42158,-646.11163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -5468.2984,2139.3147 -1e-4,-72.6955",
    id: "path1537",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 22.99656296,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.26458332,0,0,0.26458332,-244.17261,-97.60714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -5468.2981,2503.45 -2e-4,-246.9574",
    id: "path1506",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 22.99656296,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.26458332,0,0,0.26458332,-244.17261,-97.60714)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1690.9932,
    cy: 483.92142,
    id: "path1512",
    r: 15.501632,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 6.08450699,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1547",
    style: {
      strokeWidth: 0.65704465
    },
    transform: "matrix(1.5226963,0,0,1.5212372,449.92948,-646.11163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -5314.7551,2305.2388 -10e-5,-238.6196",
    id: "path1530",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 22.99656296,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.26458332,0,0,0.26458332,-244.17261,-97.60714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -5314.7548,2503.45 -2e-4,-81.0333",
    id: "path1510",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 22.99656296,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.26458332,0,0,0.26458332,-244.17261,-97.60714)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1650.3682,
    cy: 527.8219,
    id: "circle1514",
    r: 15.501632,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 6.08450699,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1552",
    style: {
      strokeWidth: 0.65704465
    },
    transform: "matrix(1.5226963,0,0,1.5212372,405.22898,-644.48531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -5044.0344,2186.7228 V 2062.5786",
    id: "path1523",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 22.99656296,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.26458332,0,0,0.26458332,-244.17261,-97.60714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -5044.034,2499.4094 V 2303.9001",
    id: "path1508",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 22.99656296,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.26458332,0,0,0.26458332,-244.17261,-97.60714)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1578.74,
    cy: 496.46475,
    id: "circle1516",
    r: 15.501632,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 6.08450699,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2634",
    transform: "translate(-228.22613,-219.40648)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 175.95261,
    id: "rect989-0",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 116.03008,
    x: -2262.1172,
    y: -1850.6493
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2212.1083,-1762.673 h 132.0424",
    id: "path993-1",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2080.066,-1762.673 -38.8891,38.0512",
    id: "path995-0",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2080.066,-1762.673 -38.8891,-38.0511",
    id: "path997-6",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2640",
    transform: "translate(-215.52613,-196.22155)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 175.95261,
    id: "rect2604",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 116.03008,
    x: -1895.1715,
    y: -1873.8342
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1713.1202,-1785.858 h -132.0424",
    id: "path2606",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1845.1625,-1785.858 38.8891,38.0512",
    id: "path2608",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1845.1625,-1785.858 38.8891,-38.0511",
    id: "path2610",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2158",
    transform: "translate(-1893.2508,-908.48397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -822.94577,-666.60436 -2.7e-4,50.63486 c 0,1.26358 -0.84285,2.28081 -1.89013,2.28081 h -172.17305 c -1.04714,0 -1.89013,-1.01723 -1.89013,-2.28081 v -50.63486",
    id: "rect1147-4",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041508,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1663-9",
    transform: "translate(-755.12118,-593.01002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -155.80138,-47.138367 V -197.97334",
    id: "path1149-7",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -155.80138,-197.97325 -43.48169,44.42384",
    id: "path1151-5",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -155.80138,-197.97325 43.4817,44.42384",
    id: "path1153-4",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 292.19891,-1203.8827 h 175.7822",
    id: "path1245-9",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1713",
    transform: "translate(152.39999,-1113.3666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -239.45954,-110.08035 H -63.67736",
    id: "path1245",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -151.56845,-197.97144 V -22.189261",
    id: "path1709",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2089",
    transform: "translate(-401.07507,-1192.8655)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -840.60016,
    cy: -2602.1973,
    id: "ellipse1717",
    rx: 57.371502,
    ry: 56.435123,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(0.70704084,-0.70717272,0.70704084,0.70717272,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2315.1744,-1126.74 -79.1057,-79.1204",
    id: "path1719",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2472.2481,-1245.7533 h 76.0993",
    id: "path1721",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2434.1984,-1283.803 v 76.0993",
    id: "path1723",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2094",
    transform: "translate(63.36091,-1101.9938)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -566.17584,
    cy: -2456.2729,
    id: "ellipse1725",
    rx: 57.371502,
    ry: 56.435123,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(0.70704084,-0.70717272,0.70704084,0.70717272,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2017.9707,-1217.6117 -79.1057,-79.1203",
    id: "path1727",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2175.0444,-1336.625 h 76.0993",
    id: "path1729",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2083",
    transform: "translate(-7.44964,-822.12455)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1449",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "64.96838379px",
      lineHeight: 3.3499999,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: -2507.1326,
    xmlSpace: "preserve",
    y: -1592.7974
  }, /*#__PURE__*/React.createElement("tspan", {
    dx: 0,
    dy: 0,
    id: "tspan1447",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "Verdana",
      InkscapeFontSpecification: "Verdana",
      letterSpacing: "-11.87653065px",
      strokeWidth: 0.37970105
    },
    transform: "matrix(0.69682017,0,0,0.69682017,-67.153659,-55.007348)",
    x: -2507.1326,
    y: -1592.7974
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: -598.08905,
    cy: -2883.9441,
    id: "ellipse1731",
    rx: 57.371502,
    ry: 56.435123,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(0.70704084,-0.70717272,0.70704084,0.70717272,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2342.9156,-1497.4809 -79.1058,-79.1204",
    id: "path1733",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2189",
    transform: "translate(-3120.8611,-421.04619)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 153.94724,
    id: "rect931",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 153.94724,
    x: 228.71378,
    y: -496.77704
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 250.71444,-496.77699 v -22.00073 0 h 153.94724 v 153.94724 h -22.00073",
    id: "path1745",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2202",
    transform: "translate(-312.38402,-1532.9212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 392.74279,-12.27948 h -71.21026 c -61.03471,0 -61.03471,-93.20769 5.20191,-93.20769 h 90.48202 35.06893",
    id: "path993-9",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 452.28539,-105.48717 -38.8891,38.05115",
    id: "path995-1",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 452.28539,-105.48717 -38.8891,-38.05115",
    id: "path997-1",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2214",
    transform: "translate(56.75471,-1230.2967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -460.4089,-314.90398 h 71.21026 c 61.0347,0 61.0347,-93.20769 -5.20191,-93.20769 h -90.48202 -35.06893",
    id: "path1801",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -519.9515,-408.11167 38.8891,38.05115",
    id: "path1803",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -519.9515,-408.11167 38.8891,-38.05115",
    id: "path1805",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2197",
    transform: "translate(-1808.65,-1076.8045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 184.0267,-110.90647 88.823128,-22.978113",
    id: "path1803-1",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 184.0267,-110.90647 88.823128,-198.83482",
    id: "path1805-1",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2193",
    transform: "translate(-2672.4487,-836.66045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -179.32648,-367.22226 95.203558,87.92835",
    id: "path1803-1-2",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -179.32648,-367.22226 95.203558,-87.92836",
    id: "path1805-1-8",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2226",
    transform: "translate(164.23835,-1072.3573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1871",
    style: {
      strokeWidth: 0.97482073
    },
    transform: "matrix(1.0260175,0,0,1.0256418,-467.16513,-277.97446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -158.46651,96.671625 38.88909,38.051155",
    id: "path1803-14",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.02724552,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -158.46651,96.671625 38.88909,-38.05115",
    id: "path1805-8",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.02724552,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m -629.80255,-110.38615 c 0,27.680812 16.68063,52.63599 42.26373,63.228983 25.58311,10.592992 55.03053,4.737675 74.61101,-14.835612 19.58046,-19.573296 25.43792,-49.009931 14.84104,-74.583681 -10.59687,-25.57373 -35.13,-42.24554 -62.82095,-42.24554 l -68.84199,0.003",
    id: "path1884",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m -1514.9723,-863.95421 h -175.9495 l 90.0418,-75.8658 z m -106.8185,100.0737 h -46.5326 v -100.0739 h 129.1794 v 100.0739 h -46.5326 m -36.1145,-0.1181 v -48.0593 0 h 36.1147 v 48.0593",
    id: "path1891",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2220",
    transform: "translate(-24.144967,-1106.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1919",
    style: {
      strokeWidth: 0.97482073
    },
    transform: "matrix(-1.0260175,0,0,1.0256418,-903.16509,-277.97446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -158.46651,96.671625 38.88909,38.051155",
    id: "path1915",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.02724552,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -158.46651,96.671625 38.88909,-38.05115",
    id: "path1917",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.02724552,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m -740.52767,-110.38615 c 0,27.680812 -16.68063,52.63599 -42.26373,63.228983 -25.58311,10.592992 -55.03053,4.737675 -74.61101,-14.835612 -19.58046,-19.573296 -25.43792,-49.009931 -14.84104,-74.583681 10.59687,-25.57373 35.13,-42.24554 62.82095,-42.24554 l 68.84199,0.003",
    id: "path1921",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2107",
    transform: "translate(-240.94651,-1137.5163)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -690.90137,
    cy: -1105.1691,
    id: "path1934",
    r: 87.973946,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -690.90137,
    cy: -1105.1691,
    id: "circle1936",
    r: 59.536469,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 335.03003,-1227.9151 20.04987,20.0499",
    id: "path1962",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 230.78314,-1332.162 20.04987,20.0499",
    id: "path1940",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 250.833,-1227.9151 -20.04986,20.0499",
    id: "path1955",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 355.0799,-1332.162 -20.04987,20.0499",
    id: "path1942",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2185",
    transform: "translate(-291.46694,-1158.5175)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.39822,
    cy: 693.55414,
    id: "ellipse1423-3",
    rx: 31.198929,
    ry: 31.634565,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(-9.6138809e-5,-1,1,9.0481721e-5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 837.76177,-452.3395 -112.58661,-0.006",
    id: "path1425-8",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 781.1025,-426.26069 0.006,-26.05829",
    id: "path1992",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 799.02985,-430.77546 0.006,-21.57197",
    id: "path1994",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 816.9572,-426.2826 0.006,-26.0583",
    id: "path1998",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m -112.51194,-183.04153 38.319677,95.424145 102.595188,6.9565 -78.912325,65.931857 25.087632,99.723499 -87.090172,-54.676016 -87.09018,54.676012 25.08764,-99.723494 -78.91232,-65.931866 102.59518,-6.956492 z",
    id: "path2006",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 14.84131432,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(0.62426871,0,0,0.62365538,895.34637,-1173.309)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2209",
    transform: "translate(-1.4089037,-1533.7002)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 518.29993,
    cy: 619.60132,
    id: "ellipse1490-5",
    rx: 23.976822,
    ry: 23.822092,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26110744,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(0.50750515,-0.86164873,0.87029421,0.49253221,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.42236,
    cy: 684.8418,
    id: "ellipse2023",
    rx: 23.976822,
    ry: 23.822092,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26110744,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(0.50750515,-0.86164873,0.87029421,0.49253221,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 525.33441,
    cy: 762.38867,
    id: "ellipse2025",
    rx: 23.976822,
    ry: 23.822092,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26110744,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(0.50750515,-0.86164873,0.87029421,0.49253221,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 827.83933,-128.56733 76.63311,38.524913",
    id: "path2042",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 823.82442,-23.719791 84.73882,-42.599805",
    id: "path2046",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2054",
    transform: "rotate(90,-767.89394,-2037.6176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.239132,-367.22227 113.4427,-455.15062",
    id: "path2048",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.23914,-367.22227 95.20356,87.92836",
    id: "path2050",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2060",
    transform: "matrix(0,-1,-1,0,-2440.5654,-1139.8306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.239132,-367.22227 113.4427,-455.15062",
    id: "path2056",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.23914,-367.22227 95.20356,87.92836",
    id: "path2058",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2314",
    transform: "translate(-516.09273,-545.50889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2266",
    transform: "translate(-2502.509,196.92612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2274-8",
    transform: "translate(1989.0802,-136.04491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -179.32648,-367.22226 95.203558,-62.4843",
    id: "path2264-2",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -179.32648,-367.22226 95.203558,62.4843",
    id: "path2270-3",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 1800.4444,-591.19554 v 175.8567",
    id: "path2268-6",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2307",
    transform: "translate(-398.88743,-550.17048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2274",
    transform: "matrix(-0.99999999,0,0,0.99999999,-537.4539,65.542778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -179.32648,-367.22226 95.203558,-62.4843",
    id: "path2264",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -179.32648,-367.22226 95.203558,62.4843",
    id: "path2270",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m -348.81804,-389.60782 v 175.85669",
    id: "path2268",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2390",
    transform: "translate(1422.7737,-675.91523)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -1833.8696,
    cy: -222.45903,
    id: "circle2373",
    rx: 41.306015,
    ry: 41.448803,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1921.5762,-88.029044 h 175.4132 m -175.4132,2e-6 a 87.974326,86.256897 0 0 1 -0.2678,-6.724292 87.974326,86.256897 0 0 1 87.9743,-86.256896 87.974326,86.256897 0 0 1 87.9744,86.256896 v 0 a 87.974326,86.256897 0 0 1 -0.2679,6.725982",
    id: "path2385",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2400",
    transform: "translate(-4.6466675)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 67.944372,-879.66206 c -5.379,-20.22358 -23.8631,-34.31947 -45.0035,-34.31947 -1.6883,0 -3.3754,0.0908 -5.0537,0.27224 m -39.8743,34.0132 c -0.5235,-0.0196 -1.0473,-0.0294 -1.5711,-0.0294 -22.901,-10e-6 -41.4659,18.36411 -41.4659,41.01743 0,9.84637 2.1625,21.35929 10.0738,26.79863 42.6468,29.3213 113.1667,29.32745 155.809298,2e-5 7.9097,-5.43989 10.0648,-16.95225 10.0648,-26.79862 0,-22.65332 -18.564898,-41.01744 -41.465898,-41.01743 -0.5238,0 -1.0476,0.01 -1.5711,0.0294 m -89.9315,0.034 c 5.379,-20.22358 23.8630997,-34.31947 45.0035,-34.31947 1.6883,0 3.3754,0.0908 5.0537,0.27224",
    id: "path2510",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 175.94791,
    id: "rect2519",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 175.94791,
    x: -429.92664,
    y: -2070.0535
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2543",
    style: {
      opacity: 1
    },
    transform: "translate(108.06574,-1823.5804)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 25.929165,
    id: "rect2525",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 25.929165,
    x: -516.69342,
    y: -200.03868
  }), /*#__PURE__*/React.createElement("rect", {
    height: 25.929165,
    id: "rect2527",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 25.929165,
    x: -462.983,
    y: -200.03868
  }), /*#__PURE__*/React.createElement("rect", {
    height: 25.929165,
    id: "rect2529",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 25.929165,
    x: -409.27258,
    y: -200.03868
  }), /*#__PURE__*/React.createElement("rect", {
    height: 25.929165,
    id: "rect2531",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 25.929165,
    x: -516.69342,
    y: -142.88869
  }), /*#__PURE__*/React.createElement("rect", {
    height: 25.929165,
    id: "rect2533",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 25.929165,
    x: -462.983,
    y: -142.88869
  }), /*#__PURE__*/React.createElement("rect", {
    height: 25.929165,
    id: "rect2535",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 25.929165,
    x: -409.27258,
    y: -142.88869
  })), /*#__PURE__*/React.createElement("rect", {
    height: 139.34364,
    id: "rect2545",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 175.94791,
    x: -429.92664,
    y: -2051.7512
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2135-2",
    transform: "translate(-65.37061,-968.71081)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 175.95261,
    id: "rect989-0-8",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 116.03008,
    x: -1630.547,
    y: -1101.345
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2645"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -1696.5682,-1013.3687 h 132.0424",
    id: "path993-1-6",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1564.5259,-1013.3687 -38.8891,38.05119",
    id: "path995-0-7",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1564.5259,-1013.3687 -38.8891,-38.0511",
    id: "path997-6-6",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2597",
    transform: "translate(1196.0887,623.78773)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 175.95261,
    id: "rect2589",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 6.19999981,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 116.03008,
    x: -2486.6648,
    y: -2693.8435
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2420.6435,-2605.8673 h -132.0424",
    id: "path2591",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2552.6858,-2605.8673 38.8891,38.0512",
    id: "path2593",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2552.6858,-2605.8673 38.8891,-38.0511",
    id: "path2595",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2694",
    transform: "translate(-131.23332,-432.5953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 510.39322,-419.2546 h 99.0598",
    id: "path2325",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 510.39322,-478.4401 h 99.0598",
    id: "path2327",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 510.39322,-360.06921 h 99.0598",
    id: "path2329",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491.23651,
    cy: -478.44009,
    id: "path1755",
    r: 4.630208,
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491.23651,
    cy: -419.25464,
    id: "path1755-5",
    r: 4.630208,
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491.23651,
    cy: -360.06921,
    id: "path1755-2",
    r: 4.630208,
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 433.62349,-419.2546 h 38.45635",
    id: "path2653",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 433.62349,-478.4401 h 38.45635",
    id: "path2655",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 433.62349,-360.06921 h 38.45635",
    id: "path2657",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m -2794.5038,-2031.0828 c -7.0159,-7.7603 -14.0319,-15.5207 -21.0478,-23.281 -11.7868,0 -23.5737,0 -35.3605,0 m -32.9111,23.281 c 7.0159,-7.7603 14.0319,-15.5207 21.0478,-23.281 11.7868,0 23.5737,0 35.3605,0 m 111.2154,144.5691 c -58.6493,0 -117.2986,0 -175.9479,0 0,-40.4294 0,-80.8587 0,-121.2881 58.6493,0 117.2986,0 175.9479,0 0,40.4294 0,80.8587 0,121.2881 z",
    id: "path2662",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2742"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 105.58412,
    id: "rect2666",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041508,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 175.94792,
    x: 744.32074,
    y: -2034.8716
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 920.26868,-2034.8716 -175.96193,-0.3367 87.69092,78.011 z",
    id: "path2668",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 803.84583,-1981.9173 -59.539,52.9667 175.96185,-0.3369 -59.79582,-52.6174 -28.46131,25.0444 z",
    id: "path2671",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m -1185.807,-2341.5635 v -133.0631 h -42.6218 v 155.0684 h 61.8115 v -175.9433 h -83.0773 v 153.938",
    id: "path2677",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2737",
    transform: "translate(-30.107552,-18.971792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 763.41671,-840.01578 a 150.88508,154.11206 0 0 1 50.68894,-8.95671 150.88508,154.11206 0 0 1 50.68635,8.95576",
    id: "path2696",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 744.75814,-872.99241 a 187.68634,191.70036 0 0 1 69.35474,-13.56839 187.68634,191.70036 0 0 1 69.33769,13.56145",
    id: "circle2698",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 726.19227,-905.84079 a 224.48756,229.28865 0 0 1 87.90085,-18.30833 224.48756,229.28865 0 0 1 87.92332,18.3181",
    id: "circle2700",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 814.10437,
    cy: -798.31799,
    id: "path2723",
    rx: 18.761122,
    ry: 18.7672,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ffffff",
      strokeWidth: 9.26041603,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLight);
export default __webpack_public_path__ + "static/media/file_light.a39c90158dc86a306c658a12bf371c8d.svg";
export { ForwardRef as ReactComponent };